import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import instancesReducer from "./slices/instancesSlice";
import tableReducer from "./slices/tableSlice";
import notificationReducer from "./slices/notificationSlice";
import instanceHistoryReducer from "./slices/instanceHistorySlice";
import tenantsReducer from "./slices/tenantsSlice";
import dashboardReducer from "./slices/dashboardSlice";
import userPreferencesReducer from "./slices/userPreferencesSlice";
import communityReducer from "./slices/communitySlice";
import uiReducer from "./slices/uiSlice";
import surveyBuilderReducer from "./slices/surveyBuilderSlice";
import surveyDistributionReducer from "./slices/surveyDistributionSlice";
import { baseApi } from "./api/baseApi";
import { publicApi } from "./api/publicApi";

const rootReducer = combineReducers({
  authReducer,
  instanceHistoryReducer,
  instancesReducer,
  tableReducer,
  notificationReducer,
  tenantsReducer,
  dashboardReducer,
  userPreferencesReducer,
  communityReducer,
  uiReducer,
  surveyBuilderReducer,
  surveyDistributionReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [publicApi.reducerPath]: publicApi.reducer,
});

export default rootReducer;
